import { Link } from "react-router-dom";

export default function () {

    return <div className="bg-base-200 fixed top-0 left-0 w-screen h-screen z-[9999] flex justify-center items-center flex-col gap-4">
        <h1 className="text-5xl font-bold">404</h1>
        <h1 className="text-2xl font-bold">Aradığınız sayfa bulunamadı!</h1>
        <Link to={"/"} className="link link-primary">Anasayfaya Geri Dön</Link>
    </div>
}